const SvgSkillCount=()=>{
    return(
        <>
         <svg
                        width="25"
                        height="25"
                        className="max-md:max-w-[20px] max-md:max-h-[20px] "
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="10.5" cy="10.5" r="10.5" fill="white" />
                        <line
                          x1="5"
                          y1="10.3662"
                          x2="16"
                          y2="10.3662"
                          stroke="#1F9DFC"
                        />
                        <line
                          x1="10.6334"
                          y1="5"
                          x2="10.6334"
                          y2="16"
                          stroke="#1F9DFC"
                        />
                      </svg>
        
        </>

    );
};
export default SvgSkillCount;